// angular
import { Component, Input, OnDestroy, OnInit, Output, ViewEncapsulation, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { CoreService } from '../../../core/core.service';

// others
import { AppService } from '../../../app.service';
import { AuthService } from '../../../core/auth.service';
import { MeSelfReportService } from '../me-self-report.service';

@Component({
    selector: 'me-sr-help-card',
    templateUrl: './help-card.component.html',
    styleUrls: ['./help-card.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class MeSelfReportHelpCardComponent implements OnInit {
    data: any;
    url = 'self-evaluation/steps/help-card';
    form: FormGroup;
    submitted: boolean;

    @Input() callApi = true;
    @Input() blockData = false;
    @Output() updateUI = new EventEmitter(); 


    constructor(
        public appService: AppService,
        public coreService: CoreService,
        public translate: TranslateService,
        public authService: AuthService,
        public meSelfReportService : MeSelfReportService,
    ) {
    }

    ngOnInit() {
        if (this.callApi) {
            this.getContent();
        } else {
            this.data = this.blockData['content'];
        }

        this.translate.onLangChange.subscribe(value => {
            this.getContent();
        });
    }

    ngAfterViewInit() {
        this.coreService.className = 'me-landing-page';
    }

    getContent() {
        this.appService.getStoryBlokDataForClinic(this.url).subscribe(res => {
            this.data = res['story']['content'] ?? [];
            this.appService.isLoading = false;
        });
    }

    next() {
        let step = this.meSelfReportService.srStep + 1;
        this.appService.isLoading = true;
        // to do call api to BE to update sr step
        this.meSelfReportService.updateSRStep(step).subscribe(() => {
            this.appService.isLoading = false;
            this.meSelfReportService.srStep = step;
            this.updateUI.emit();
        });
    }
}
